// @flow
import { handleActions } from 'redux-actions';
import {
    OPEN, CLOSE_BY_KEY, CLOSE_TOPMOST, CLOSE_ALL, SET_SENSITIVITY, SET_TITLE,
} from './constants';


export type SidePanel = {
    +url: string,
    +sensitive: boolean | { message: string },
    +continuity: boolean,
    +closeIfNotTopmost: ?boolean,
    +props: ?Object,
    +title: ?string,
};

export type State = { +[string]: SidePanel };


const initialState: State = {};

const reducer = handleActions({
    [OPEN]: (state: State, { payload }: {
        payload: {
            key: string,
            title: ?string,
            url: string,
            sensitive: boolean | Object,
            continuity: ?boolean,
            closeIfNotTopmost: ?boolean,
            additionalProps: Object,
        }
    }) => {
        const {
            key, title, url, sensitive, continuity, closeIfNotTopmost, additionalProps,
        } = payload;

        const newState = { ...state };
        Object.keys(newState)
            .filter((panelKey) => newState[panelKey].closeIfNotTopmost)
            .forEach((panelKey) => delete newState[panelKey]);

        return {
            ...newState,
            [key]: {
                title, url, sensitive, continuity, closeIfNotTopmost, additionalProps,
            },
        };
    },
    [CLOSE_BY_KEY]: (state: State, { payload }: {
        payload: {
            key: string,
        },
    }) => {
        const newState = { ...state };
        delete newState[payload.key];

        return newState;
    },
    [CLOSE_TOPMOST]: (state: State) => {
        const newState = { ...state };
        delete newState[Object.keys(state).pop()];

        return newState;
    },
    [CLOSE_ALL]: (state: State) => {
        const newState = { ...state };
        Object.entries(newState).forEach(([key, value]) => {
            if (!value.continuity) {
                delete newState[key];
            }
        });
        return newState;
    },
    [SET_SENSITIVITY]: (state: State, { payload }: {
        payload: {
            key: string,
            url: string,
            sensitive: boolean | Object,
        }
    }) => {
        const { key, sensitive } = payload;

        return {
            ...state,
            [key]: {
                ...state[key],
                sensitive,
            },
        };
    },
    [SET_TITLE]: (state: State, { payload }: {
        payload: {
            key: string,
            url: string,
            sensitive: boolean | Object,
        }
    }) => {
        const { key, title } = payload;

        return {
            ...state,
            [key]: {
                ...state[key],
                title,
            },
        };
    },
}, initialState);

export default reducer;
